<div class="form-div text-center">
  <div class="">
    <img
      class="logo-img"
      [src]="'assets/flyplus/app-logo.svg' | assets"
      alt=""
    />
  </div>
  <div class="my-3 px-0">
    <div class="row">
      <div class="col-sm-12">
        <div class="row bars-row">
          <div class="col">
            <div class="progress" style="height: 5px" placement="bottom">
              <div
                class="progress-bar in-progress-bar"
                role=" progressbar"
                [ngStyle]="{ width: '100%' }"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
          </div>
          <div class="col">
            <div class="progress" style="height: 5px" placement="bottom">
              <div
                class="progress-bar progress-bar-striped progress-bar-animated in-progress-bar"
                role=" progressbar"
                [ngStyle]="{ width: '100%' }"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="mt-5">
    <h5 class="fw-700" translate>Please verify your phone number</h5>
    <p class="sub-label" translate>OTP will be sent to the selected number</p>
  </div>
  <form [formGroup]="verifyOtpForm" novalidate appTrackForm>
    <div class="login-error" [hidden]="!error || isLoading" translate>
      OTP code is incorrect.
    </div>
    <br />
    <div class="login-fields d-flex flex-column">
      <!-- <mat-form-field [hideRequiredMarker]="true" appearance="outline">
      <mat-label translate>Enter the code we sent to you</mat-label>
      <input
        type="text"
        matInput
        formControlName="code"
        maxlength="6"
        required
        />
    </mat-form-field> -->
      <ng-otp-input
        class="text-center"
        [formCtrl]="verifyOtpForm?.controls?.code"
        [config]="otpConfig"
      ></ng-otp-input>
      <div class="forgot-password my-3 text-secondary">
        <div translate>Didn't receive the OTP yet?</div>
        @if (isTimerActive) {
          <span class="fw-600">
            <span translate> Resend OTP in </span>
            {{ getTimerText(timer) | numberTranslate }}</span
          >
        }
        @if (!isTimerActive && !isLoading) {
          <a class="resend-otp-link c-pointer" (click)="resendOtp()" translate
            >Resend OTP?</a
          >
        }
      </div>
      <button
        mat-flat-button
        color="primary"
        (click)="verifyOTP()"
        type="submit"
        [disabled]="verifyOtpForm.invalid || isLoading"
        appTrackClick="verify-otp-verify-otp-btn"
        ctaType="primary"
      >
        <app-loader class="inline-loader" [isLoading]="isLoading"></app-loader>
        <span translate>Verify OTP</span>
      </button>
    </div>
  </form>
  <div class="mt-5 text-center">
    <img
      [src]="'assets/flyplus/powered-by.png' | assets"
      width="130"
      class="mt-5 mb-3"
    />
  </div>
</div>
